import {
  Box,
  Button,
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

import { useCurrentUserQuery } from '../../user/hooks/useCurrentUserQuery';

export const AppBar: FunctionComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery(true);
  return (
    <div>
      <MuiAppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="subtitle2" color="inherit">
            {'La Flute'}
          </Typography>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            {currentUserData ? (
              <Button
                href="/dashboard"
                sx={{
                  color: 'primary.main',
                  ml: 2,
                  backgroundColor: 'white',
                  ':hover': {
                    color: 'white',
                  },
                }}
                variant="contained"
                color="primary"
              >
                {'Mon espace'}
              </Button>
            ) : (
              <>
                <Button
                  href="/login"
                  sx={{
                    color: 'white',
                    ml: 2,
                    borderColor: 'white',
                    ':hover': {
                      color: 'primary.main',
                      backgroundColor: 'white',
                    },
                  }}
                  variant="outlined"
                >
                  {'Se connecter'}
                </Button>
                <Button
                  href="/create-account"
                  sx={{
                    color: 'primary.main',
                    ml: 2,
                    backgroundColor: 'white',
                    ':hover': {
                      color: 'white',
                    },
                  }}
                  variant="contained"
                  color="primary"
                >
                  {"S'enregistrer"}
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </MuiAppBar>
      <Toolbar />
    </div>
  );
};
